import React from 'react';
import { Tag } from 'antd';
import { AlgorithmVersion, TestResultRow } from '../../../types';
import { Link } from 'react-router-dom';
import { ColumnType } from 'antd/lib/table';

export const getDatasetOverviewTableColumns = (onClickUrl: (testResultRow: TestResultRow) => any) => {
  return [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      sorter: (a: TestResultRow, b: TestResultRow) => a.file_id.localeCompare(b.file_id),
      render: (text: string, testResultRow: TestResultRow) => (
        <span>
          <Link className="block my-1" to={onClickUrl(testResultRow)}>
            {testResultRow.file_id}
          </Link>
        </span>
      ),
    },
    {
      title: 'Incorrect fields',
      key: 'incorrect_fields',
      dataIndex: 'incorrect_fields',
      filters: [
        {
          text: 'Has incorrect fields',
          value: '1',
        },
        {
          text: 'No incorrect fields',
          value: '0',
        },
      ],
      onFilter: (value: string | number | boolean, record: TestResultRow) => {
        return +value === 0 ? record.incorrect_fields === +value : record.incorrect_fields >= +value;
      },
      sorter: (a: TestResultRow, b: TestResultRow) => (a.incorrect_fields > b.incorrect_fields ? -1 : 1),
      render: (text: string, testResultRow: TestResultRow) => {
        return (
          <span>
            <Tag color={testResultRow.incorrect_fields > 0 ? 'red' : 'green'}>{testResultRow.incorrect_fields}</Tag>
          </span>
        );
      },
    },
  ];
};

export const getDatasetOverviewTableComparingColumns = (
  onClickUrl: (testResultRow: any, algorithmVersionId?: string | undefined) => any,
  algorithmVersions: AlgorithmVersion[] | null
) => {
  const columns: ColumnType<any>[] = [...(algorithmVersions || [])]
    .sort((a, b) => (a?.timeCreated! > b?.timeCreated! ? 1 : -1))
    .map((algoVersion) => {
      const property = ('version_' + algoVersion.id) as keyof {};

      return {
        title: `Incorrect fields: ${algoVersion?.version}`,
        key: 'version_' + algoVersion.id,
        dataIndex: 'version_' + algoVersion.id,
        filters: [
          {
            text: 'Has incorrect fields',
            value: '1',
          },
          {
            text: 'No incorrect fields',
            value: '0',
          },
        ],
        onFilter: (value: string | number | boolean, record) => {
          return +value === 0 ? record[property] === +value : (record[property] as number) >= +value;
        },
        sorter: (a, b) => {
          return (a[property] === null ? -1 : a[property]) > (b[property] === null ? -1 : b[property]) ? -1 : 1;
        },
        render: (text: string, testResultCompare) => {
          return (
            <span>
              {testResultCompare[property] === null ? null : (
                <Link to={onClickUrl(testResultCompare, algoVersion.id)}>
                  <Tag color={testResultCompare[property] > 0 ? 'red' : 'green'}>{testResultCompare[property]}</Tag>
                </Link>
              )}
            </span>
          );
        },
      };
    });

  return [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      sorter: (a: any, b: any) => a.file_id.localeCompare(b.file_id),
      render: (text: string, testResultCompare: any) => (
        <span>
          <Link className="block my-1" to={onClickUrl(testResultCompare)}>
            {testResultCompare.file_id}
          </Link>
        </span>
      ),
    },
    ...columns,
  ];
};
